<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
       <el-breadcrumb-item v-if="circleType === 'community'" :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
       <el-breadcrumb-item v-if="circleType === 'union'" :to="{ path: '/union/:id', query: { id: circleTypeId } }">联盟生态</el-breadcrumb-item>
       <el-breadcrumb-item v-if="circleType === 'research'" :to="{ path: '/research/:id', query: { id: circleTypeId } }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item>{{circleName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 我的圈子 -->
    <div class="glag_left">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>我的{{circleName}}</span>
        </p>
        <el-divider></el-divider>
      </div>
      <div class="my_circle"
      :class="myBoard.length === 0 ? 'my_none' : ''"
      v-loading="loading.my"
      element-loading-text="列表加载中"
      element-loading-spinner="el-icon-loading">
        <circle-view
        v-if="myBoard.length > 0"
        :list="myBoard"
        :type="boardType.my"
        :limit="myBoardPage.limit"
        @page="page"
        @edit="editBoard"
        @apply="applyBoard"
        @retreat = "retreatBoard">
        </circle-view>
        <div v-if="myBoard.length === 0 && !loading.my" class="my_none">您还没有创建属于自己的{{circleName}}，快来<a class="my_none_btn" @click="boardLayer('add')">创建</a>吧！</div>
      </div>
    </div>
    <!-- 用户信息 -->
    <div class="glag_right">
      <div v-if="user !== null" class="circle_user_info">
        <div class="circle_user_pic">
          <img :src="user.user.pic" alt="">
        </div>
        <dl class="circle_user_content">
          <dt>{{user.user.user_name}}</dt>
          <dd>{{user.user.content}}</dd>
        </dl>
        <div class="circle_user_other">
          <dl><dt>{{user.my_board_count}}</dt><dd>我创建的</dd></dl>
          <el-divider direction="vertical"></el-divider>
          <dl><dt>{{user.join_board_count}}</dt><dd>我已加入的</dd></dl>
          <el-divider direction="vertical"></el-divider>
          <button class="my_follow_btn" @click="boardLayer('add')"><span>+</span>创建</button>
          <!-- 创建圈子弹窗 -->
          <el-dialog :title="addBoardTitle"
          :visible.sync = "addBoardOnOff"
          :close-on-click-modal = 'false'
          :show-close = 'false'
          :close-on-press-escape = 'false'
          >
            <el-form :model="addBoardForm" :rules="rules" ref="addBoardForm" :hide-required-asterisk='true'>
              <el-form-item label="名称" prop="board_name">
                <el-input v-show="!editOnOff || addBoardForm.is_delete === 0" v-model="addBoardForm.board_name" autocomplete="off"></el-input>
                <el-input v-show="editOnOff && addBoardForm.is_delete !== 0" v-model="addBoardForm.board_name" :disabled="true" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="简介" prop="content">
                <el-input  type="textarea" rows="3" v-model="addBoardForm.content" show-word-limit maxlength="50" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="头像">
                <img-upload-view :filestype="addBoardForm.filesType" :imgurl="addBoardForm.pic" @files="imgFile"></img-upload-view>
              </el-form-item>
            </el-form>
            <div v-if="!dialogBtnOnOff" slot="footer" class="dialog-footer">
              <el-button @click="addBoardOnOff = false">取 消</el-button>
              <el-button v-show="!editOnOff" type="primary" @click="createBoard('addBoardForm')">确 定</el-button>
              <el-button v-show="editOnOff" type="primary" @click="editBoardSub('addBoardForm')">确 定</el-button>
            </div>
            <div v-else slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="true">提交中</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <!-- 热门圈子 -->
      <div v-if="hotBoard.length > 0" class="glag_right">
        <div class="title_top_hr">
          <p>
            <span>热门{{circleName}}</span>
            <a class="rt" @click.prevent="hotMore"><b class="el-icon-refresh"></b> 换一换</a>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="hot_circle"
        v-loading="loading.hot"
        element-loading-text="列表加载中"
        element-loading-spinner="el-icon-loading">
          <div v-for="(item, index) in hotBoard" :key = "item.id" class="hot_circle_item">
            <div class="hot_circle_left" @click="jump(item.board_id)">
              <img :src="item.pic" alt="">
            </div>
            <div class="hot_circle_right">
              <div class="hot_circle_title" @click="jump(item.board_id)">{{item.board_name}}</div>
              <div class="hot_circle_info">
                <span>{{item.user_name}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.numbers}} 位成员</span>
              </div>
            </div>
            <div class="hot_circle_button">
              <button v-show="item.is_join === 0"
              class="greenglga_btn"
              @click="applyBoard(item.board_id, index, boardType.hot)"
              >
                <span>加入</span>
              </button>
              <button v-show="item.is_join === 1"
              :class="hoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
              @mouseenter="hoverIndex = index"
              @mouseleave="hoverIndex = ''"
              @click = "retreatBoard(item.board_id, index, boardType.hot)">
                <span v-show="hoverIndex !== index">已加入</span>
                <span v-show="hoverIndex === index">退出</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 已加入圈子 -->
    <div class="glag_left">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>已加入{{circleName}}</span>
        </p>
        <el-divider></el-divider>
      </div>
      <div class="my_join_circle"
      :class="joinBoard.length === 0 ? 'my_none' : ''"
      v-loading="loading.join"
      element-loading-text="列表加载中"
      element-loading-spinner="el-icon-loading">
        <circle-view
        v-if="joinBoard.length > 0"
        :list="joinBoard"
        :type="boardType.join"
        :limit="joinBoardPage.limit"
        @page="page"
        @apply="applyBoard"
        @retreat = "retreatBoard">
        </circle-view>
        <div v-if="joinBoard.length === 0 && !loading.join" class="my_none">您暂未加入任何{{circleName}}！</div>
      </div>
    </div>

    <!-- 所有圈子列表 -->
    <div class="glag_left">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>{{circleName}}</span>
        </p>
        <el-divider></el-divider>
      </div>
      <div class="circle_list"
      :class="timeBoard.length === 0 ? 'my_none' : ''"
      v-loading="loading.time"
      element-loading-text="列表加载中"
      element-loading-spinner="el-icon-loading">
        <circle-view
        v-if="timeBoard.length > 0"
        :list="timeBoard"
        :type="boardType.time"
        :limit="timeBoardPage.limit"
        @page="page"
        @apply="applyBoard"
        @retreat = "retreatBoard">
        </circle-view>
        <div v-if="timeBoard.length === 0 && !loading.time" class="my_none">暂无其它{{circleName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import circle from '../Public/circle.vue'
import imgupload from '../Public/imgUpload.vue'
export default {
  components: {
    circleView: circle,
    imgUploadView: imgupload
  },
  data () {
    return {
      circleType: '', // 加载类型 社区生态、联盟生态、研究院生态
      circleTypeId: '', // 加载类 联盟id、研究院id
      circleName: '', // 名称   圈子、俱乐部、生活部落
      hoverIndex: -1, // 人们圈子鼠标移入记录下标
      loading: { // 加载状态
        my: true,
        join: true,
        time: true,
        hot: true
      },
      limit: 4,
      addBoardOnOff: false, // 创建圈子弹窗开关
      addBoardTitle: '创建', // 创建圈子弹窗开关
      editOnOff: false, // 修改圈子开关
      editBoardInfo: { // 修改圈子相关信息
        id: '',
        index: ''
      },
      addBoardForm: { // 创建圈子表单提交内容
        board_name: '',
        content: '',
        pic: '',
        filesType: 'circleImg',
        create_type: '',
        union_id: '',
        research_id: ''
      },
      rules: { // 创建圈子验证规则
        board_name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ]
      },
      dialogBtnOnOff: false, // 圈子弹窗按钮提交加载不可点击，防止重复点击
      user: null, // 圈子列表用户信息
      myBoard: [], // 我的圈子列表
      myBoardPage: { // 我的圈子列表分页
        page: 1,
        limit: 4,
        type: '',
        research_id: '',
        union_id: ''
      },
      joinBoard: [], // 我加入的圈子列表
      joinBoardPage: { // 我加入的圈子列表分页
        page: 1,
        limit: 4,
        type: '',
        research_id: '',
        union_id: ''
      },
      hotBoard: [], // 热度圈子列表
      hotBoardPage: { // 热度圈子列表分页
        page: 1,
        limit: 6,
        type: '',
        research_id: '',
        union_id: ''
      },
      timeBoard: [], // 时间子列表
      timeBoardPage: { // 时间圈子列表分页
        page: 1,
        limit: 6,
        type: '',
        research_id: '',
        union_id: ''
      },
      boardType: {
        my: 'my',
        join: 'join',
        hot: 'hot',
        time: 'time'
      }
    }
  },
  created () {
    this.circleType = this.$route.query.type
    this.circleTypeId = this.$route.query.id
    if (this.circleType === 'community') {
      this.circleName = '圈子'
      this.addBoardForm.create_type = 1
      this.myBoardPage.type = 1
      this.joinBoardPage.type = 1
      this.hotBoardPage.type = 1
      this.timeBoardPage.type = 1
    } else if (this.circleType === 'union') {
      this.circleName = '俱乐部'
      this.addBoardForm.create_type = 2
      this.addBoardForm.union_id = this.circleTypeId
      this.myBoardPage.type = 2
      this.myBoardPage.union_id = this.circleTypeId
      this.joinBoardPage.type = 2
      this.joinBoardPage.union_id = this.circleTypeId
      this.hotBoardPage.type = 2
      this.hotBoardPage.union_id = this.circleTypeId
      this.timeBoardPage.type = 2
      this.timeBoardPage.union_id = this.circleTypeId
    } else {
      this.circleName = '生活部落'
      this.addBoardForm.create_type = 3
      this.addBoardForm.research_id = this.circleTypeId
      this.myBoardPage.type = 3
      this.myBoardPage.research_id = this.circleTypeId
      this.joinBoardPage.type = 3
      this.joinBoardPage.research_id = this.circleTypeId
      this.hotBoardPage.type = 3
      this.hotBoardPage.research_id = this.circleTypeId
      this.timeBoardPage.type = 3
      this.timeBoardPage.research_id = this.circleTypeId
    }
    this.createApi()
  },
  mounted () {
    document.title = this.circleName
  },
  methods: {
    // 页面首次接口获取
    async createApi () {
      const vueThat = this
      // 获取用户信息
      await vueThat.myApi.boardGetMyInfo().then((res) => {
        if (res.data.code === 200) {
          vueThat.user = res.data.data
        }
      })
      // 获取我的圈子列表
      await vueThat.myApi.boardIndex(vueThat.myBoardPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.myBoard = res.data.data.data
          vueThat.loading.my = false
        }
      })
      // 获取我加入的圈子列表
      await vueThat.myApi.myJoinBoardList(vueThat.joinBoardPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.joinBoard = res.data.data.data
          vueThat.loading.join = false
        }
      })
      // 获取时间排序圈子列表
      await vueThat.myApi.getNewestBoardList(vueThat.timeBoardPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.timeBoard = res.data.data
          vueThat.loading.time = false
        }
      })
      // 获取热门圈子
      await vueThat.myApi.getHotBoardList(vueThat.hotBoardPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.hotBoard = res.data.data
          vueThat.loading.hot = false
        }
      })
    },
    // 获取图片上传组件传递的图片地址
    imgFile (url) {
      this.addBoardForm.pic = url
    },
    // 圈子弹窗弹出
    boardLayer (type) {
      const vueThat = this
      vueThat.addBoardOnOff = true
      if (type === 'add') {
        vueThat.addBoardTitle = '创建'
        vueThat.addBoardForm.board_name = ''
        vueThat.addBoardForm.content = ''
        vueThat.addBoardForm.pic = ''
        vueThat.addBoardForm.editOnOff = false
      } else {
        vueThat.addBoardTitle = '修改信息'
      }
    },
    // 创建圈子弹窗
    createBoard (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          vueThat.dialogBtnOnOff = true
          if (vueThat.addBoardForm.pic === '') {
            vueThat.$message({
              message: '请上传头像',
              type: 'error'
            })
            vueThat.dialogBtnOnOff = false
          } else {
            vueThat.myApi.createBoard(vueThat.addBoardForm).then((res) => {
              if (res.data.code === 200) {
                this.$alert('创建成功', '温馨提示', {
                  confirmButtonText: '确定',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  type: 'success',
                  callback: action => {
                    vueThat.loading.my = true
                    vueThat.addBoardOnOff = false
                    vueThat.$refs[formName].resetFields()
                    vueThat.addBoardForm.pic = ' '
                    vueThat.dialogBtnOnOff = false
                    // 获取我的圈子列表
                    vueThat.myBoardPage.page = 1
                    vueThat.myApi.boardIndex(vueThat.myBoardPage).then((res) => {
                      if (res.data.code === 200) {
                        window.location.reload()
                      }
                    })
                  }
                })
              } else {
                vueThat.dialogBtnOnOff = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 修改圈子信息提交接口
    editBoardSub (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          vueThat.dialogBtnOnOff = true
          if (vueThat.addBoardForm.pic === '') {
            vueThat.$message({
              message: '请上传头像',
              type: 'error'
            })
            vueThat.dialogBtnOnOff = false
          } else {
            const obj = vueThat.addBoardForm
            obj.board_id = vueThat.editBoardInfo.id
            obj.synopsis = vueThat.addBoardForm.content
            vueThat.myApi.eoardEditSub(vueThat.addBoardForm).then((res) => {
              if (res.data.code === 200) {
                this.$alert('信息修改成功', '温馨提示', {
                  confirmButtonText: '确定',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  type: 'success',
                  callback: action => {
                    const obj1 = Object.assign(vueThat.myBoard[vueThat.editBoardInfo.index], vueThat.addBoardForm)
                    vueThat.myBoard.splice(vueThat.editBoardInfo.index, 1, obj1)
                    vueThat.addBoardOnOff = false
                    vueThat.editOnOff = false
                    vueThat.editBoarId = ''
                    vueThat.$refs[formName].resetFields()
                    vueThat.addBoardForm.pic = ' '
                    vueThat.dialogBtnOnOff = false
                  }
                })
              } else {
                vueThat.dialogBtnOnOff = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 修改圈子弹窗弹出信息
    editBoard (data, index) {
      const vueThat = this
      vueThat.addBoardTitle = '修改信息'
      vueThat.editBoardInfo.id = data.board_id
      vueThat.editBoardInfo.index = index
      vueThat.editOnOff = true
      vueThat.addBoardOnOff = true
      vueThat.addBoardForm.board_name = data.board_name
      vueThat.addBoardForm.content = data.synopsis
      vueThat.addBoardForm.pic = data.pic
      vueThat.addBoardForm.is_delete = data.is_delete
    },
    // 圈子列表加载更多
    page (num, type) {
      const vueThat = this
      switch (type) {
        case 'my':
          vueThat.myBoardPage.page = num
          vueThat.myApi.boardIndex(vueThat.myBoardPage).then((res) => {
            if (res.data.code === 200) {
              if (vueThat.myBoard.length === 0) {
                vueThat.myBoard = res.data.data.data
              } else {
                vueThat.myBoard.push(...res.data.data.data)
              }
            }
          })
          break
        case 'join':
          vueThat.joinBoardPage.page = num
          vueThat.myApi.myJoinBoardList(vueThat.joinBoardPage).then((res) => {
            if (res.data.code === 200) {
              if (vueThat.joinBoard.length === 0) {
                vueThat.joinBoard = res.data.data.data
              } else {
                vueThat.joinBoard.push(...res.data.data.data)
              }
            }
          })
          break
        case 'hot':
          vueThat.hotBoardPage.page = num
          vueThat.myApi.getHotBoardList(vueThat.hotBoardPage).then((res) => {
            if (res.data.code === 200) {
              if (vueThat.hotBoard.length === 0) {
                vueThat.hotBoard = res.data.data
              } else {
                vueThat.hotBoard.push(...res.data.data)
              }
            }
          })
          break
        case 'time':
          vueThat.timeBoardPage.page = num
          vueThat.myApi.getNewestBoardList(vueThat.timeBoardPage).then((res) => {
            if (res.data.code === 200) {
              if (vueThat.timeBoard.length === 0) {
                vueThat.timeBoard = res.data.data
              } else {
                vueThat.timeBoard.push(...res.data.data)
              }
            }
          })
          break
      }
    },
    // 加入圈子
    applyBoard (id, index, type) {
      const vueThat = this
      vueThat.myApi.applyBoard({ board_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$message({
            message: '加入成功！',
            type: 'success'
          })
          switch (type) { // is_join 值 0为未加入 1为已加入
            case 'join':
              vueThat.$set(this.joinBoard[index], 'is_join', 1)
              console.log(this.joinBoard[index])
              break
            case 'hot':
              vueThat.$set(this.hotBoard[index], 'is_join', 1)
              break
            case 'time':
              vueThat.$set(this.timeBoard[index], 'is_join', 1)
              break
          }
        }
      })
    },
    // 退出圈子
    retreatBoard (id, index, type) {
      const vueThat = this
      vueThat.$confirm('退出后将无法获取信息，是否确认退出？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        vueThat.myApi.retreatBoard({ board_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '退出成功！',
              type: 'success'
            })
            switch (type) { // is_join 值 0为未加入 1为已加入
              case 'join':
                vueThat.$set(vueThat.joinBoard[index], 'is_join', 0)
                break
              case 'hot':
                vueThat.$set(vueThat.hotBoard[index], 'is_join', 0)
                break
              case 'time':
                vueThat.$set(vueThat.timeBoard[index], 'is_join', 0)
                break
            }
          }
        })
      }).catch(() => {})
    },
    // 热门圈子换一换
    async hotMore () {
      const vueThat = this
      if (vueThat.hotBoard.length === 6) {
        vueThat.hotBoardPage.page += 1
      } else {
        vueThat.hotBoardPage.page = 1
      }
      await vueThat.myApi.getHotBoardList(vueThat.hotBoardPage).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.length === 0) {
            vueThat.hotBoardPage.page = 1
            vueThat.myApi.getHotBoardList(vueThat.hotBoardPage).then((res) => {
              if (res.data.code === 200) {
                vueThat.hotBoard = res.data.data
              }
            })
          } else {
            vueThat.hotBoard = res.data.data
          }
        }
      })
    },
    // 圈子帖子列表跳转
    jump (rid) {
      const routeData = this.$router.resolve({
        path: '/cirlePostList/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>
</style>
